<div class="search-modal">
        <nalco-tab (selectedTab)="selectedTab($event)">
            <nalco-tab-container *ngFor="let item of tabs; trackBy: trackByTabName" [label]="item.name | translate" [isActive]="item.isActive" [info]="item.enableCustomerDivisionSelection ? item.enableCustomerDivisionSelection : false">
                <ng-template>
                    <nalco-search-bar-and-result [searchData]="searchData" [tabValue]="item"
                        (selectedResult)="emitSearchedResult($event)" (selectedResultInHierarchy)="saveSelectedResultInHierarchy($event)" (multipleSelectedResult)="emitMultipleSelection($event)"></nalco-search-bar-and-result>
                </ng-template>
            </nalco-tab-container>
        </nalco-tab>
</div>